<template>
  <div class="animated fadeIn">
    <!-- <b-card no-body >
      <b-card-body class="p-4"> -->
    <b-form validated novalidate @submit="changeAccess">
      <b-col sm="12">
        <b-form-group
          label-for="shifting_status"
          label="Generate akses ke sistem"
        >
          <b-form-radio-group
            id="shifting_status"
            v-model="authorizationFlag"
            :options="listGenerateAuthentication"
          ></b-form-radio-group>
          <b-form-invalid-feedback
            >Generat akses ke sistem harus di isi.</b-form-invalid-feedback
          >
        </b-form-group>
      </b-col>

      <b-button type="submit" variant="success">Change Access</b-button>
    </b-form>
    <!-- </b-card-body>
    </b-card> -->
  </div>
</template>

<script>
import axios from "axios";
import globalTable from "@/templates/Table.vue";
import masterInterfaces from "@/templates/_master_interfaces.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import { ModelSelect, MultiSelect } from "vue-search-select";
import loading from "@/templates/Loading.vue";
export default {
  name: "employee-config-access",
  components: { loading, ModelSelect, MultiSelect, loading },
  data() {
    return {
      authorizationFlag: null,
      listGenerateAuthentication: [
        { value: 1, text: "Tidak" },
        { value: 2, text: "Ya" },
      ],
    };
  },
  props: {
    isDisable: {
      type: Boolean,
      default: true,
    },
    nik: {
      type: String,
      default: "",
    },
    loadingParam: {
      type: Boolean,
      default: true,
    },
    childAddButton: {
      type: Boolean,
      default: false,
    },
    authorization: {
      type: Number,
      default: false,
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  validations: {
    accessForm: {
      authorizationFlag: { required },
    },
  },

  methods: {
    init: function () {
      this.resetForm();
    },

    back: function () {
      this.$router.go(-1);
    },

    resetForm: function () {
      for (var a in masterInterfaces.change_password) {
        masterInterfaces.change_password[a] = null;
      }
      this.accessForm = masterInterfaces.change_password;
    },

    back: function () {
      this.$router.go(-1);
    },
    changeAccess: function (evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin merubah access karyawan ini ?")) {
        if (this.authorizationFlag === null) {
          alert("Harap pilih salah satu");
          this.resetForm();
          let route = this.$route.path.split("/");
          this.init(route[4]);
        } else {
          let param = {
            nik: this.nik,
            authorization: this.authorizationFlag,
          };
          this.axios
            .put("web/employee/change-employee-access/", param)
            .then((response) => {
              this.showInfoNotification({
                title: "Ubah Access",
                message: response.data.message,
              });
            })
            .catch((error) => {
              this.expired(error, "Ubah Access");
            })
            .finally(() => {
              this.resetForm();
              let route = this.$route.path.split("/");
              this.init(route[4]);
            });
        }
      }
    },
    expired: function (error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired",
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message,
        });
      }
    },
  },
  mounted() {
    let route = this.$route.path.split("/");
    this.init(route[4]);
  },
};
</script>
